import React from 'react';
import { Tag, Tooltip } from 'antd';
import type { ImageDescriptor } from '@/api/ProductImages/types';
import { useTranslate } from '@/translations';

export const ImageQualityTag = ({
  image,
}: {
  image?: Pick<ImageDescriptor, 'sourceKind' | 'qualityScore'> | null;
}) => {
  const { t } = useTranslate();
  if (
    image?.sourceKind !== 'Generated' ||
    image.qualityScore == null ||
    image.qualityScore >= 95
  )
    return null;
  return (
    <Tooltip
      title={t('imagery.belowThresholdScore', { score: image.qualityScore })}
    >
      <Tag color="warning" className="imagery-quality-tag">
        {t('imagery.belowThreshold')}
      </Tag>
    </Tooltip>
  );
};
